import React, { Component }
    from 'react';
import { Redirect, Link }
    from "react-router-dom";
import logo_img_new from './../assets/images/Muvi_Logo_Blue_White.svg';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import Cookies from 'js-cookie';
class Login extends Component {
    constructor(props) {
        super(props);
        document.title = 'Intranet | Login';
        this.state = {
            email: '',
            password: '',
            redirect: false,
            redirectPath: Cookies.get('redirectPath') ? Cookies.get('redirectPath') : '/home',
            message: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
        }
        this.login = this.login.bind(this);
        this.onChange = this.onChange.bind(this);
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;

    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    login() {

        if (this.state.email && this.state.password) {
            document.getElementById("login_btn").innerHTML = "Sending....";
            document.getElementById("login_btn").disabled = true;
            fetch(this.state.apiUrl + '/site/UserLogin', {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((response) => response.json())
                .then((result) => {
                    var encdata = result.encdata;
                    result = this.decrypt(encdata, 0);
                    console.log(result);

                    if (result.code === 200) {
                        Cookies.remove('redirectPath');
                        localStorage.setItem('userLogin', 'yes');
                        localStorage.setItem('encdata', encdata);
                        this.setState({ redirect: true });
                        // window.parent.location = window.parent.location.href; //login
                        window.parent.location = "/home";
                    } else {
                        this.setState({ message: result.msg });
                        document.getElementById("login_btn").innerHTML = "Login";
                        document.getElementById("login_btn").disabled = false;
                    }
                })
                .catch((error) => {
                    console.error(error);
                    // reject(error);
                });
        } else {
            this.setState({ message: 'Please enter valid Username and Password' });
        }

    }

    onChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }
    render() {
        if (this.state.redirect || localStorage.getItem('userLogin')) {
            return (
                <Redirect to={this.state.redirectPath} />
            )
        }
        return (
            <div class="limiter">
                <div class="logo">
                    <a href="#"><img src={logo_img_new} /></a>
                </div>
                <div class="container-login100">
                    <div class="wrap-login">
                        <div class="login100-form validate-form">
                            <form action="javascript:void(0);" onSubmit={() => this.login()}>
                                <span class="login100-form-title">
                                    Login
                                </span>

                                <span class="txt1">
                                    Username
                                </span>
                                <div class="wrap-input100" data-validate="Username is required">
                                    {/* <input class="input100" type="text" name="username"/> */}
                                    <input type="email" name="email" class="input100" onChange={
                                        this.onChange} />
                                    <span class="focus-input100"> </span>
                                </div>

                                <span class="txt1">
                                    Password
                                </span>
                                <div class="wrap-input100 validate-input" data-validate="Password is required">
                                    {
/* <input class="input100" type="password" name="pass"/> */}
                                    <input type="password" name="password" class="input100" onChange={
                                        this.onChange} />
                                    <span class="focus-input100"></span>
                                </div>

                                <div class="flex-sb-m">
                                    <div class="contact100-form-checkbox">
                                        <input class="input-checkbox100" id="ckb1" type="checkbox" name="remember-me" />
                                        <label class="label-checkbox100" for="ckb1">
                                            Remember me
                                        </label>
                                    </div>

                                    <div>

                                        {/* Forgot Password? 5.03.19*/}
                                        <Link to="/Forgetpassword" class="color-sky">
                                            Forgot Password?
                                        </Link>

                                    </div>
                                </div>
                                <span className="error"> {
                                    this.state.message}</span>
                                <div class="container-login100-form-btn">
                                    <button type="submit" id="login_btn" class="login100-form-btn btn btn-sky" >Login</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}
export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js